module.exports = __webpack_public_path__ + "static/media/ready.60827cc4.svg";